module.exports = __webpack_public_path__ + "static/media/calendar-white.cdf1f9c4.svg";